'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Delete = {};

exports.__exports = Delete;
